import { render, staticRenderFns } from "./cloud-reports.component.vue?vue&type=template&id=36d3483b&"
import script from "./cloud-reports.component.vue?vue&type=script&lang=tsx&"
export * from "./cloud-reports.component.vue?vue&type=script&lang=tsx&"
import style0 from "./cloud-reports.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports